// extracted by mini-css-extract-plugin
export default {"maindiv":"Home_maindiv__etDLX","togglediv":"Home_togglediv__SZBSR","toggleBtn":"Home_toggleBtn__YFMdu","activeBtn":"Home_activeBtn__35ha5"};